import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AppLayout from "../../components/ui/AppLayout";
import PageHeader from "../../components/ui/PageHeader";
import SectionCard from "../../components/ui/SectionCard";
import GameForm from "./GameForm";
import api from "../../api";

const CadastrarJogoPage = () => {
  const navigate = useNavigate();
  const [times, setTimes] = useState([]);
  const [goleiros, setGoleiros] = useState([]);
  const [torneioId, setTorneioId] = useState(null);
  const [torneioNome, setTorneioNome] = useState("");
  const [values, setValues] = useState({
    time1: "", time2: "", goleiroTime1: "", goleiroTime2: "", dataJogo: "", placarTime1: 0, placarTime2: 0, isSemiFinal: false, isFinal: false,
  });
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState(null);

  useEffect(() => {
    const fetchTorneioData = async () => {
      try {
        const torneioResponse = await api.get("/getTorneioActive");
        const torneio = torneioResponse.data;
        const timesResponse = await api.get("/times");

        setGoleiros(torneio.goleiros || []);
        setTorneioId(torneio._id);
        setTorneioNome(torneio.nome);
        setTimes(timesResponse.data.times);
      } catch (error) {
        setSnackbar({ severity: "error", message: "Erro ao buscar dados do torneio." });
      }
    };
    fetchTorneioData();
  }, []);

  const handleSubmit = async () => {
    if (!values.time1 || !values.time2 || values.time1 === values.time2) {
      setSnackbar({ severity: "error", message: "Selecione dois times diferentes." });
      return;
    }
    setSaving(true);
    try {
      await api.post("/cadastro-jogos", { ...values, torneioId });
      navigate("/listar-jogos");
    } catch (error) {
      setSnackbar({ severity: "error", message: "Erro ao cadastrar o jogo." });
    }
    setSaving(false);
  };

  return (
    <AppLayout maxWidth="md">
      <PageHeader backTo="/torneio" eyebrow={torneioNome} title="Cadastrar jogo" />
      <SectionCard>
        <GameForm times={times} goleiros={goleiros} values={values} onChange={setValues} showPhase />
        <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 3 }}>
          <Button color="inherit" onClick={() => navigate("/torneio")}>Cancelar</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={saving}>Cadastrar jogo</Button>
        </Stack>
      </SectionCard>
      <Snackbar open={Boolean(snackbar)} autoHideDuration={6000} onClose={() => setSnackbar(null)}>
        {snackbar ? <Alert onClose={() => setSnackbar(null)} severity={snackbar.severity} variant="filled">{snackbar.message}</Alert> : <span />}
      </Snackbar>
    </AppLayout>
  );
};

export default CadastrarJogoPage;
